import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginWindow from 'Components/loginWindow';
import 'Styles/main.scss';
import 'Styles/commonElements.scss';
import 'Styles/commonComponents.scss';
import AppStore from 'Stores/AppStore';
import { observer } from 'mobx-react';
import App from 'Components/app.js';
import AlertsHolder from "Components/AlertsHolder/AlertsHolder";
import ErrorWindow from "Components/errorWindow";

class MainContainer extends React.Component {
    componentDidMount() {
        AppStore.GetServiceState();
    }

    render() {
        return (
            <div className="main-with-alerts-archive">
                <AlertsHolder loggedIn={AppStore.loggedIn} />
                <Routes>
                    <Route
                        path={`${window.SmrLocation}/login`}
                        element={<LoginWindow
                            version={AppStore.smrVersion}
                            firstPingDone={AppStore.firstPingDone}
                            doesSmrWork={AppStore.smrWorkState.doesSmrWork}
                            loggedIn={AppStore.loggedIn}
                            lastPageInfo={AppStore.lastPageInfo}
                        />}
                    />
                    <Route
                        path={`${window.SmrLocation}/error`}
                        element={<ErrorWindow smrWorkState={AppStore.smrWorkState}
                            version={AppStore.smrVersion}
                            printSmrStartError={AppStore.PrintSmrStartError}
                        />}
                    />
                    <Route
                        path={`${window.SmrLocation}/*`}
                        element={<App />}
                    />
                </Routes>
            </div>
        );
    }
};

export default observer(MainContainer);